export default [
  {
    title: '时间',
    key: 'tdate',
    sortable: 'custom',
    type: 'basic',
    width: 100
  },
  {
    title: '新增关联素材数',
    key: 'relatedMaterialsNum',
    type: 'basic',
    width: 100
  },

  {
    title: '总关联素材数',
    key: 'relatedMaterialsTotal',
    type: 'basic',
    width: 100
  },
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    sortable: 'custom',
    type: 'basic',
    width: 88
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    type: 'basic',
    width: 88
  },
  {
    title: '激活数',
    key: 'downNum',
    sortable: 'custom',
    type: 'basic',
    width: 72
  },
  {
    title: '注册数',
    key: 'newUserNum',
    sortable: 'custom',
    type: 'basic',
    width: 72
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    sortable: 'custom',
    type: 'basic',
    width: 70
  },
  {
    title: '新建角色数',
    key: 'newRoleNum',
    sortable: 'custom',
    type: 'basic',
    width: 98
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    type: 'basic',
    width: 82
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    sortable: 'custom',
    type: 'basic',
    width: 82
  },
  {
    title: '创角率',
    key: 'createRoleRate',
    sortable: 'custom',
    type: 'basic',
    width: 74
  },
  {
    title: '首日付费创角数',
    key: 'payRoleUserNum',
    sortable: 'custom',
    type: 'basic',
    width: 118
  },
  {
    title: '首日创角付费率',
    key: 'payRoleUserRate',
    sortable: 'custom',
    type: 'basic',
    width: 118
  },

  {
    title: '新创角付费成本',
    key: 'newPayCost',
    sortable: 'custom',
    type: 'basic',
    width: 118
  },

  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    sortable: 'custom',
    type: 'basic',
    width: 118
  },

  {
    title: '新创角回款率',
    key: 'newRoleRate',
    sortable: 'custom',
    type: 'basic',
    width: 118
  },

  {
    title: '1日ROI',
    key: 'createRoleRoi1d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },
  {
    title: '3日ROI',
    key: 'createRoleRoi3d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },
  {
    title: '7日ROI',
    key: 'createRoleRoi7d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },
  {
    title: '15日ROI',
    key: 'createRoleRoi15d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },
  {
    title: '30日ROI',
    key: 'createRoleRoi30d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },

  {
    title: '创角次留',
    key: 'createRoleTwoDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角3留',
    key: 'createRoleThreeDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角4留',
    key: 'createRoleFourDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角5留',
    key: 'createRoleFiveDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角6留',
    key: 'createRoleSixDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角7留',
    key: 'createRoleSevenDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角10留',
    key: 'createRoleTenDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角15留',
    key: 'createRoleFifteenDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角30留',
    key: 'createRoleThirtyDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角1日LTV',
    key: 'createRoleOneDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角2日LTV',
    key: 'createRoleTwoDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角3日LTV',
    key: 'createRoleThreeDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角4日LTV',
    key: 'createRoleFourDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角5日LTV',
    key: 'createRoleFiveDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角6日LTV',
    key: 'createRoleSixDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角7日LTV',
    key: 'createRoleSevenDayLtv',
    type: 'other',
    width: 78
  },
  {
    title: '创角10日LTV',
    key: 'createRoleTenDayLtv',
    type: 'other',
    width: 82
  },
  {
    title: '创角15日LTV',
    key: 'createRoleFifteenDayLtv',
    type: 'other',
    width: 82
  },
  {
    title: '创角30日LTV',
    key: 'createRoleThirtyDayLtv',
    type: 'other',
    width: 82
  },

  {
    title: '创角付费次留',
    key: 'twoDayNewPayRoleRetain',
    type: 'analysis',
    sortable: 'custom',
    width: 88,
    checked: false
  },
  {
    title: '创角付费3留',
    key: 'threeDayNewPayRoleRetain',
    type: 'analysis',
    sortable: 'custom',
    width: 88,
    checked: false
  },
  {
    title: '创角付费4留',
    key: 'fourDayNewPayRoleRetain',
    type: 'analysis',
    sortable: 'custom',
    width: 88,
    checked: false
  },
  {
    title: '创角付费5留',
    key: 'fiveDayNewPayRoleRetain',
    type: 'analysis',
    sortable: 'custom',
    width: 88,
    checked: false
  },
  {
    title: '创角付费6留',
    key: 'sixDayNewPayRoleRetain',
    type: 'analysis',
    sortable: 'custom',
    width: 88,
    checked: false
  },
  {
    title: '创角付费7留',
    key: 'sevenDayNewPayRoleRetain',
    type: 'analysis',
    sortable: 'custom',
    width: 88,
    checked: false
  },
  {
    title: '创角付费10留',
    key: 'tenDayNewPayRoleRetain',
    type: 'analysis',
    sortable: 'custom',
    width: 98,
    checked: false
  },
  {
    title: '创角付费15留',
    key: 'fifteenDayNewPayRoleRetain',
    type: 'analysis',
    sortable: 'custom',
    width: 98,
    checked: false
  },
  {
    title: '创角付费30留',
    key: 'thirtyDayNewPayRoleRetain',
    type: 'analysis',
    sortable: 'custom',
    width: 98,
    checked: false
  }
]
